// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.minimass.test/' : 'https://api.minimass.net/';
export const contentAPI = 'https://api.minimass.net/';

export const origin = 'https://www.minimass.net';

export const urlRoots = ['minimass'];

export const useLanguageURLRoots = false;
